/* FOODHUB - Section "NOS GUIDES D'EXPERT" => tout clic redirige vers /blogs/journal */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function init() {
    var headings = document.querySelectorAll('h1, h2, h3, h4');
    var guidesTitle = null;
    for (var i = 0; i < headings.length; i++) {
      var txt = (headings[i].innerText || '').toUpperCase();
      if (txt.indexOf("NOS GUIDES D'EXPERT") !== -1 || txt.indexOf('NOS GUIDES DâEXPERT') !== -1) {
        guidesTitle = headings[i];
        break;
      }
    }
    if (!guidesTitle) return;

    var section = guidesTitle.closest('section, [class*="section"]');
    if (!section) return;
    if (section.dataset.guidesRedirectInit) return;
    section.dataset.guidesRedirectInit = '1';

    var target = '/blogs/journal';

    var links = section.querySelectorAll('a');
    for (var k = 0; k < links.length; k++) {
      links[k].setAttribute('href', target);
    }

    section.style.cursor = 'pointer';
    section.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      window.location.href = target;
    });
  }

  ready(init);
})();
